import { component } from 'picoapp';

export default component(async (node) => {
  const classes = {
    active: 'faq__item--active',
  };
  const items = node.querySelectorAll('[data-item]');

  const showItem = (target) => {
    items.forEach((item) => {
      const content = item.lastElementChild;

      if (item === target) {
        item.classList.toggle(classes.active);
        content.hidden = !content.hidden;
      } else {
        item.classList.remove(classes.active);
        content.hidden = true;
      }
    });
  };

  items.forEach((item) => {
    const title = item.firstElementChild;

    title.addEventListener('click', () => {
      showItem(item);
    });
  });
});
